import React from 'react';
import Skeleton from './Skeleton';

type SkeletonProps = {
  className?: string;
};

/** Shimmer block for a numeric or unknown dynamic value. */
export function SkeletonValue({ className = 'h-6 w-12' }: SkeletonProps) {
  return <Skeleton className={className} rounded="md" />;
}

export function SkeletonText({ className = 'h-4 w-24' }: SkeletonProps) {
  return <Skeleton className={className} rounded="md" />;
}

export default SkeletonValue;
